import { array, string, func, bool } from 'prop-types'

import LoadingIcon from '~/src/components/LoadingIcon/index.js'
import CodeScanner from '~/src/components/CodeScanner/index.js'

import SeriesList from './SeriesList/index.js'
import FilterList from './FilterList/index.js'
import StocksTable from './StocksTable/index.js'
import ProductsList from './ProductsList/index.js'

function Page(props) {
  const {
    stocksData,
    productsData,
    getStocks,
    setCurSeries,
    search,
    setSearch,
    hideEmpty,
    setHideEmpty,
    sortBy,
    setSortBy,
    openScanner,
    closeScanner,
    isScannerOpen,
    onScanResult,
    isLoading,
  } = props
  return (
    <div style={{ position: 'absolute', left: 0 }}>
      <LoadingIcon open={isLoading} />
      <SeriesList {...props} />
      <FilterList
        {...{
          search,
          setSearch,
          hideEmpty,
          setHideEmpty,
          sortBy,
          setSortBy,
          openScanner,
        }}
      />
      {isScannerOpen && <CodeScanner {...{ closeScanner, onScanResult }} />}
      {/* <CameraModal /> */}
      {Array.isArray(stocksData) && stocksData.length > 0 ? (
        <StocksTable {...{ stocksData, search, hideEmpty }} />
      ) : (
        <ProductsList {...{ productsData, getStocks, setCurSeries, search }} />
      )}
    </div>
  )
}
Page.propTypes = {
  stocksData: array,
  productsData: array,
  getStocks: func.isRequired,
  setCurSeries: func.isRequired,
  search: string,
  setSearch: func.isRequired,
  hideEmpty: bool.isRequired,
  setHideEmpty: func.isRequired,
  sortBy: string,
  setSortBy: func.isRequired,
  isLoading: bool.isRequired,
  openScanner: func.isRequired,
  closeScanner: func.isRequired,
  onScanResult: func.isRequired,
  isScannerOpen: bool.isRequired,
}

export default Page
